import { render, staticRenderFns } from "./ViewDataSearch.vue?vue&type=template&id=188d00ac&"
import script from "./ViewDataSearch.vue?vue&type=script&lang=js&"
export * from "./ViewDataSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports